import React, { useState, useEffect } from "react";
import { ArrowLeft } from "lucide-react";
import { Button } from "./ui/button";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const CGVPage = ({ onBack }) => {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const response = await axios.get(`${API}/settings`);
      setSettings(response.data);
    } catch (error) {
      console.error("Erreur:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <header className="border-b border-primary/10 sticky top-0 bg-background/95 backdrop-blur-sm z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <Button
            data-testid="back-btn"
            variant="ghost"
            onClick={onBack}
            className="flex items-center gap-2"
          >
            <ArrowLeft className="w-4 h-4" />
            Retour
          </Button>
        </div>
      </header>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-4xl text-street tracking-wide mb-8">
          Conditions Générales de Vente
        </h1>

        {loading ? (
          <div className="text-center py-12 text-muted-foreground">
            Chargement...
          </div>
        ) : settings && settings.cgv_content ? (
          <div className="glass-card rounded-lg p-8">
            <div className="prose prose-invert max-w-none">
              <div className="whitespace-pre-wrap text-muted-foreground leading-relaxed">
                {settings.cgv_content}
              </div>
            </div>
          </div>
        ) : (
          <div className="glass-card rounded-lg p-8 text-center">
            <p className="text-muted-foreground">
              Les conditions générales de vente n'ont pas encore été définies.
            </p>
            <p className="text-sm text-muted-foreground mt-2">
              Contactez l'administrateur pour plus d'informations.
            </p>
          </div>
        )}

        {/* Company Info */}
        {settings && (settings.company_name || settings.address) && (
          <div className="mt-8 p-6 bg-muted/30 rounded-lg">
            <h3 className="font-bold mb-3">Informations légales</h3>
            {settings.company_name && (
              <p className="text-sm text-muted-foreground">
                Société : {settings.company_name}
              </p>
            )}
            {settings.address && (
              <p className="text-sm text-muted-foreground">
                Adresse : {settings.address}, {settings.postal_code} {settings.city}, {settings.country}
              </p>
            )}
            {settings.email && (
              <p className="text-sm text-muted-foreground">
                Email : {settings.email}
              </p>
            )}
            {settings.phone && (
              <p className="text-sm text-muted-foreground">
                Téléphone : {settings.phone}
              </p>
            )}
          </div>
        )}
      </div>
    </div>
  );
};
